var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shopRating" },
    [
      _c("views-rating-stars", { attrs: { rating: _vm.rating } }),
      _vm._v(" "),
      _c("div", { staticClass: "shopRating__label" }, [
        _vm._v("口コミ件数：" + _vm._s(_vm.reviewCount) + "件"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }